/* This is the EMIS facilities electricity computer photocopy etc components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <div class="flex-container">
        <!-- Group column 1-->
        <div>
          <table
            style="height: 50px"
            border="1px;"
            width="270"
            cellspacing="0px;"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 170px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  អគ្គីសនី
                </td>
                <td
                  style="
                    width: 100px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  អត្ថិភាព
                </td>
              </tr>
              <tr v-for="(value, index) in 4" :key="index">
                <td
                  style="
                    width: 150px;
                    height: 32px;
                    text-align: left;
                    vertical-align: middle;
                  "
                >
                  {{ facility[index] }}
                </td>
                <!-- 4 options -->
                <td
                  v-if="index === 0"
                  style="
                    width: 100px;
                    height: 35px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  <v-select
                    class="py-0 px-1"
                    v-model="data1[index].dt[0]"
                    :items="elecType"
                    item-text="text"
                    item-value="value"
                    outline
                    hide-details
                    @keypress.native="onSelect($event, index)"
                  >
                  </v-select>
                </td>
                <!-- 2 options -->
                <td
                  v-if="index > 0"
                  style="
                    width: 100px;
                    height: 35px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  <v-select
                    class="py-0 px-1"
                    v-model="data1[index].dt[0]"
                    :items="yesNo6"
                    item-text="text"
                    item-value="value"
                    outline
                    hide-details
                    @keypress.native="onSelect2($event, index)"
                  >
                  </v-select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Group column 2-->
        <div>
          <table
            style="height: 140px"
            border="1px;"
            width="250"
            cellspacing="0px;"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 200px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  កុំព្យូទ័រ
                </td>
                <td
                  style="
                    width: 50px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  ចំនួន
                </td>
              </tr>
              <tr v-for="(value, index) in 4" :key="index">
                <td
                  style="
                    width: 200px;
                    height: 35px;
                    text-align: left;
                    vertical-align: middle;
                  "
                >
                  {{ facility2[index] }}
                </td>
                <td
                  style="
                    width: 50px;
                    height: 35px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  <numberinput v-model="data2[index].dt[0]" class="number" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Group column 3-->
        <div>
          <table
            style="height: 50px"
            border="1px;"
            width="160"
            cellspacing="0px;"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 100px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  សម្ភារបរិក្ខារ
                </td>
                <td
                  style="
                    width: 50px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  ចំនួន
                </td>
              </tr>
              <tr v-for="(value, index) in 8" :key="index">
                <td
                  v-if="index > 3"
                  style="
                    width: 100px;
                    height: 35px;
                    text-align: left;
                    vertical-align: middle;
                  "
                >
                  {{ facility2[index] }}
                </td>
                <td
                  v-if="index > 3"
                  style="
                    width: 50px;
                    height: 35px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  <numberinput v-model="data2[index].dt[0]" class="number" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Group column 4-->
        <div>
          <table
            style="height: 50px"
            border="1px;"
            width="250"
            cellspacing="0px;"
          >
            <tbody>
              <tr>
                <td
                  style="
                    width: 200px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  សម្ភារបរិក្ខារ
                </td>
                <td
                  style="
                    width: 50px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  ចំនួន
                </td>
              </tr>
              <tr v-for="(value, index) in 12" :key="index">
                <td
                  v-if="index > 7"
                  style="
                    width: 200px;
                    height: 35px;
                    text-align: left;
                    vertical-align: middle;
                  "
                >
                  {{ facility2[index] }}
                </td>
                <td
                  v-if="index > 7"
                  style="
                    width: 50px;
                    height: 35px;
                    text-align: center;
                    vertical-align: middle;
                  "
                >
                  <numberinput v-model="data2[index].dt[0]" class="number" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import {
  facility,
  facility2,
  elecType,
  yesNo6,
} from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data1", "data2", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      facility: facility,
      facility2: facility2,
      elecType: elecType,
      yesNo6: yesNo6,
    };
  },
  methods: {
    onSelect: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.data1[index].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data1[index].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.flex-container {
  display: flex;
}
.flex-container-group {
  display: flex;
  flex-wrap: stretch;
  flex-direction: column;
}
.number {
  width: 50px;
  text-align: center;
}

.flex-container-header {
  display: flex;
  flex-wrap: stretch;
  background-color: DodgerBlue;
}

.flex-container-header > div {
  background-color: #f1f1f1;
  width: 75px;
  margin: 1px;
  text-align: center;
  line-height: 50px;
  font-size: 12px;
}
.flex-container-row {
  display: flex;
  flex-wrap: stretch;
  background-color: DodgerBlue;
}

.flex-container-row > div {
  background-color: #f1f1f1;
  width: 75px;
  margin: 1px;
  text-align: center;
  line-height: 30px;
  font-size: 10px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-select__slot {
  min-height: 32px;
}
.v-input {
  font-size: 14px;
}
</style>